import React, { useEffect, useState } from 'react';
import {
  ApplicationHeaderProps,
  ApplicationType,
  CrumbObj,
  i18n,
  MBSApplicationHeader,
  PortalUserType,
  useConfigStore
} from '@fides/fides-react-components';
import {
  getReactCrumbProps,
  REACT_AH_CRUMBS_CHANGED,
  REACT_AH_DATA_READY
} from './AwApplicationHeaderHelpers/AwApplicationHeaderHelpers';

type VMType = any;

export interface AwApplicationHeaderProps extends ApplicationHeaderProps {
  vm: VMType;
  PORTAL_DIRECTORY: string;
}

export const AwApplicationHeader = (props: AwApplicationHeaderProps) => {
  const { vm, PORTAL_DIRECTORY } = props;

  const [navData, setNavData] = useState<{
    portalUser?: PortalUserType;
    applications: ApplicationType[];
  }>({
    applications: []
  });
  const [crumbsData, setCrumbsData] = useState<{
    crumbs: CrumbObj[];
    isDetailView: boolean;
    pageTitle: string;
  }>({ crumbs: [], isDetailView: false, pageTitle: '' });

  const applyLang = (lng) => {
    if (lng && i18n.language !== lng)
      i18n.changeLanguage(lng);

  };

  useEffect(() => {
    vm.$rootScope.$on(REACT_AH_DATA_READY, () => {
      const lng = vm.$rootScope.portalUser.impersonatedUser ? vm.$rootScope.portalUser.impersonatedUser.settings.language : vm.ftsMainDependencies.settings?.language;
      applyLang(lng);
      setNavData(() => {
        const portalUser = vm.$rootScope.portalUser;
        const applications = vm.ftsMainDependencies.applications || [];
        return {
          applications,
          portalUser,
          lng,
        };
      });
    });

    vm.$rootScope.$on(REACT_AH_CRUMBS_CHANGED, () => {
      const lng = vm.$rootScope.portalUser.impersonatedUser ? vm.$rootScope.portalUser.impersonatedUser.settings.language : vm.ftsMainDependencies.settings?.language;
      useConfigStore.setState({ portalUrl: vm.ftsMainDependencies.portalURL });
      applyLang(lng);
      setCrumbsData(() => {
        const defaultPageTitle = `PAGE_TITLE.${vm.$rootScope.pageTitle}`;
        const { crumbs, isDetailView, pageTitle } = getReactCrumbProps(vm.$rootScope, defaultPageTitle);
        return {
          crumbs,
          isDetailView,
          pageTitle,
        }
      });
    });
  }, []);
  const mbsApplicationHeaderProps = {
    ...navData,
    ...crumbsData,
    portalDirectory: PORTAL_DIRECTORY,
  };

  return <MBSApplicationHeader applicationHeaderProps={{}}
    mbsApplicationHeaderProps={mbsApplicationHeaderProps}/>
}
